<div class="about-tab compact">
  @for (device of devices; track device) {
    <div class="device information">
      <div class="text small-text device-when superbold">
        {{device.name}}
      </div>
      <!-- <div class="text device-text">{{device.text}}</div> -->
    </div>
  }
  <div>
    @if (devices.length > 0) {
      <div class="device information">
        <div class="text small-text device-when superbold">
          Name: N/A
          <hr>
            <br>
              DeviceId: N/A
              <hr>
                <br>
                </div>
                <!-- <div class="text device-text">{{device.text}}</div> -->
              </div>
            }
            <div>
            </div>